import React from "react";
import "../../styles/ClaimStatusSummary.scss";
const ClaimStatusSummary = (props) => {
    const { summaryData, isFoundAttechment } = props;
    const [tpaData, setTpaData] = React.useState(null);
    const [isShowAssignee, setIsShowAssignee] = React.useState(false);

    React.useEffect(() => {
        const started = ['open', 'pending'];
        const inProgress = ['approved'];
        const completed = ['paid', 'denied', 'closed', 'cancelled', 'void']
        if (started.indexOf(summaryData?.status.toLowerCase()) !== -1) {
            if (summaryData?.assignedUser?.firstName || summaryData?.assignedUser?.lastName || summaryData?.assignedUser?.name || isFoundAttechment) {
                document.getElementById('sub-bar').style.width = '67%';
            } else {
                document.getElementById('sub-bar').style.width = '33%';
            }
        } else if (inProgress.indexOf(summaryData?.status.toLowerCase()) !== -1) {
            document.getElementById('sub-bar').style.width = '67%';
        } else if (completed.indexOf(summaryData?.status.toLowerCase()) !== -1) {
            document.getElementById('sub-bar').style.width = '99%';
        }
        const localStorageData = JSON.parse(localStorage.getItem("tpa_data"));
        if (localStorageData?.is_show_assigned_user) {
            setIsShowAssignee(true);
        }
    }, [summaryData, isFoundAttechment])

    React.useEffect(() => {
        const data = JSON.parse(localStorage.getItem("tpa_data"));
        setTpaData(data);
    }, [])

    const getFormattedDate = () => {
        if (summaryData?.createdDate) {
            var date = new Date(summaryData?.createdDate);
            return (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear();
        }
        return;
    }

    const getAssigneeName = () => {
        if (tpaData?.admin_Type === 'SEA') {
            return summaryData?.assignedUser?.name ?? "(unassigned)";
        } else {
            if (!summaryData?.assignedUser?.firstName && !summaryData?.assignedUser?.lastName) {
                return "(unassigned)";
            }
            var first_name = summaryData?.assignedUser?.firstName ?? "";
            var last_name = summaryData?.assignedUser?.lastName ?? "";
            return first_name + " " + last_name;
        }
    }

    const getDifferenceDays = () => {
        if (summaryData?.createdDate) {
            var date = new Date(summaryData?.createdDate);
            var today = new Date();
            var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
            return Math.round((Math.abs((today - date) / oneDay)) + 1);
        }
        return;
    }

    const displayEmail = () => {
        if (isShowAssignee==true && summaryData?.assignedUser?.email) {
            return (
                <div className="tooltip-container email-div">
                    <div className="tooltip">
                        <a href={`mailto:${summaryData?.assignedUser?.email}?subject=Claim%20#${summaryData.claimNumber}`}><i className="fa fa-envelope claim-envelope-icon" /></a>
                        <div className="tooltiptext">
                        {displayMouseoverTextEmail()}
                        </div>
                    </div>
                </div>
            )
        } else {
            if (tpaData?.email_address) {
                return (
                    <div className="tooltip-container email-div">
                        <div className="tooltip">
                            <a href={`mailto:${tpaData?.email_address}?subject=Claim%20#${summaryData.claimNumber}`}><i className="fa fa-envelope claim-envelope-icon" /></a>
                            <div className="tooltiptext">
                            {displayMouseoverTextEmail()}
                            </div>
                        </div>
                    </div>
                )
            }
            return;
        }
    }

    const displayPhone = () => {
        if (isShowAssignee == true && summaryData?.assignedUser?.phoneNumber) {
            return (
                <div className="tooltip-container phone-div">
                    <div className="tooltip">
                        <a href={`tel:${summaryData?.assignedUser?.phoneNumber}`}><i className="fas fa-phone claim-phone-icon" /></a>
                        <div className="tooltiptext">
                        {displayMouseoverTextPhone()}
                        </div>
                    </div>
                </div>
            )
        } else {
            if (tpaData?.tel) {
                return (
                    <div className="tooltip-container phone-div">
                        <div className="tooltip">
                            <a href={`tel:${tpaData?.tel}`}><i className="fas fa-phone claim-phone-icon" /></a>
                            <div className="tooltiptext">
                            {displayMouseoverTextPhone()}
                            </div>
                        </div>
                    </div>
                )
            }
            return;
        }
    }

    const displayAssignee = () => {
        if (isShowAssignee == true) {
            return (
                <span>Assigned to: {getAssigneeName()}</span>
            )
        }else{
            <span>&nbsp;</span>
        }
    };

    const displayMouseoverTextPhone = () => {
        if (isShowAssignee == true) {
            if (!summaryData?.assignedUser?.firstName && !summaryData?.assignedUser?.lastName){           
                return (
                    <div className="tooltip-content-text">
                    Call the claims team
                </div>
                    )
            }
            return (
                <div className="tooltip-content-text">
                Call the adjuster assigned to your claim
            </div>
            )
        }else{
            return (
            <div className="tooltip-content-text">
            Call the claims team
        </div>
            )
        }
    };

    const displayMouseoverTextEmail = () => {
        if (isShowAssignee== true) {
            if (!summaryData?.assignedUser?.firstName && !summaryData?.assignedUser?.lastName) {
                return (
                    <div className="tooltip-content-text">
                    Email the claims team            
                </div>)
            }
            return (
                <div className="tooltip-content-text">
                Email the adjuster assigned to your claim
            </div>
            )
        }else{
            return (
            <div className="tooltip-content-text">
            Email the claims team            
        </div>)
        }
    };

    const formatPhoneNumber = (phoneNumberString) => {
        let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{1,3})(\d{0,3})(\d{0,4})(\d{0,4})$/);
        if (match) {
            cleaned = `(${match[1]}${match[2] ? ') ' : ''}${match[2]}${match[3] ? '-' : ''}${match[3]}${match[4] ? ' x' : ''}${match[4]}`;
        }
        return cleaned;
    }

    const getErrorMessage = () => {
        const storageData = JSON.parse(localStorage.getItem('tpa_data'));
        if (summaryData?.status && summaryData?.status.toLowerCase() !== 'open') {
            const message = "Your claim is in " + summaryData?.status + " status.  Please call us at " + formatPhoneNumber(storageData?.tel) + " if you need further assistance regarding this claim."
            return (
                <React.Fragment>
                    {message &&
                    <div className="policy-error-message-container mt-20">
                        <i className="fa fa-exclamation-circle polci-expired-icon"></i>
                        <div className="policy-expired-description">
                            {message}
                        </div>
                    </div>
                }
                </React.Fragment>
            )
        }
        return;
    }

    const displayData = () => {
        if (summaryData) {
            return (
                <React.Fragment>
                    <div className="claim-number-container">
                        <div className="claim-number">
                            Claim Number: {summaryData.claimNumber}
                        </div>
                    </div>
                    <div className="claim-status-container">
                        <div className="d-flex justify-content-between">
                            <div className="claim-status-texts">Created: {getFormattedDate()}</div>
                            <div className="claim-status-texts">Days Open: {getDifferenceDays()}</div>
                        </div>
                        <div className="claim-status-title">
                            Status: {summaryData.status} {(summaryData?.subStatus && summaryData?.subStatus?.trim() !== "") ? " - " + summaryData.subStatus.replace(/([A-Z])/g, ' $1').trim() : ""}
                        </div>
                        <div className="progress-bar">
                            <div id="sub-bar">
                            </div>
                        </div>
                        <div className="progress-bar-text">
                            <div className="claim-status-texts">Started</div>
                            <div className="claim-status-texts">In Process</div>
                            <div className="claim-status-texts">Completed</div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-15">
                            <div className="claim-user">                               
                              {displayAssignee()}                       
                            </div>
                            <div className="d-flex justify-content-center">
                                {displayEmail()}
                                {displayPhone()}
                            </div>
                        </div>
                    </div>
                    <div className="mt-5">
                        {getErrorMessage()}
                    </div>
                </React.Fragment>
            )
        }
    }

    return (
        <React.Fragment>
            {displayData()}
        </React.Fragment>
    )
};

export default ClaimStatusSummary;